<template>
  <div class="gray-back">
    <div class="mine-box-title">单位绑定</div>
    <div class="mini-form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="CCA官网账号" prop="name"
                          :rules="[{ required: true, message: 'CCA官网账号不能为空', trigger: 'blur' },]"
            >
              <el-input
                  type="text"
                  placeholder="请输入CCA官网账号"
                  v-model="formData.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="CCA官网密码" prop="password"
                          :rules="[{ required: true, message: 'CCA官网密码不能为空', trigger: 'blur' },]"
            >
              <el-input
                  type="password"
                  placeholder="请输入CCA官网密码"
                  v-model="formData.password"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="省市" prop="namekey">
              <el-cascader
                  v-model="formData.namekey"
                  ref="namekey"
                  @change="handleNamekeyChange"
                  :options="namekeyList"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="地区选择" prop="area">
              <el-cascader
                  v-model="formData.area"
                  ref="areas"
                  @change="handleAreasChange"
                  :options="areaOptions"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">提交
            </el-button>
            <el-button v-if="false" @click="resetForm('ruleForm')" plain>重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <van-form
        v-if="false"
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-cell-group>

        <van-field
            v-model="formData.name"
            :rules="[{ required: true, message: 'CCA官网账号不能为空' }]"
            label="CCA官网账号"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请输入CCA官网账号"
        />
        <van-field
            v-model="formData.password"
            :rules="[{ required: true, message: 'CCA官网密码不能为空' }]"
            label="CCA官网密码"
            type="password"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请输入CCA官网密码"
        />

        <van-field
            readonly
            clickable
            name="area"
            :value="formData.ncounty?formData.nprovince+'/'+formData.ncity+'/'+formData.ncounty:''"
            input-align="right"
            label="省市"
            placeholder="点击选择省市区"
            @click="showNamekey = true"
        />
        <van-popup v-model="showNamekey" position="bottom">
          <van-area
              :area-list="namekeyList"
              :value="formData.namekey"
              @confirm="onNamekeyConfirm"
              @cancel="showArea = false"
          />
        </van-popup>

        <van-field
            readonly
            clickable
            name="area"
            :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
            input-align="right"
            label="地区选择"
            placeholder="点击选择省市区"
            @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>


      </van-cell-group>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交
        </van-button>
      </div>
    </van-form>


  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-left: 10px;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import namekey from "../../../utils/namekey";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  Calendar
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'CertDanweiBind',
  components: {
    PicUploader,
  },
  data: function () {
    return {
      validator,
      showDate: false,
      showArea: false,
      showNamekey: false,
      namekeyList: [],
      saveLoading: false,
      areaOptions: [],
      areaValue: '',
      submitType: '',
      minDate: new Date((new Date()).valueOf() + 3600 * 24 * 15 * 1000), //15天后
      formData: {
        id: 0,
        name: '',
        password: '',
        areas: '',
        nprovince: '',
        ncity: '',
        ncounty: '',
        province: '',
        city: '',
        county: '',
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "单位绑定"
    that.getAreaOptions()
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels
      console.log('handleAreasChange',values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },

    handleNamekeyChange(values) {
      let data = this.$refs.namekey.getCheckedNodes()[0].pathLabels
      this.formData.namekey = values[2];
      this.formData.nprovince = data[0];
      this.formData.ncity = data[1];
      this.formData.ncounty = data[2];
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称

      console.log(that.formData)
      that.$refs[formName].validate((valid) => {
        if (valid) {
          for (let field in that.formData) {

            if (!this.formData.area) {
              this.$message.info('请选择地区');
              return
            }
            if (!this.formData.namekey) {
              this.$message.info('请选择省市');
              return
            }
          }
          that.saveLoading = true;
          that.$api.post("/api/danwei/bind", that.formData, (res) => {
            that.saveLoading = false;
            rbLink({
              name: 'CertDanweiResult',
            }, 'replace')
          }, (rs) => {
            that.$message.error(rs.msg)
            that.saveLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },


    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
        if (!this.formData.namekey) {
          Toast('请选择省市');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/danwei/bind', that.formData, (res) => {
        that.saveLoading = false;
        rbLink({
          name: 'CertDanweiResult',
        }, 'replace')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// CertDanweiBind.vue?8ae6b17e